export default __webpack_public_path__ + "img/bxNqSvTm.9b80d51a.svg";